import { render } from "./Biz.vue?vue&type=template&id=87cb01ba"
import script from "./Biz.vue?vue&type=script&setup=true&lang=js"
export * from "./Biz.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/Biz.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87cb01ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87cb01ba', __exports__)) {
    api.reload('87cb01ba', __exports__)
  }
  
  module.hot.accept("./Biz.vue?vue&type=template&id=87cb01ba", () => {
    api.rerender('87cb01ba', render)
  })

}


export default __exports__